/* eslint-disable react/function-component-definition */
import '@nosferatu500/react-sortable-tree/style.css';
import './NodesGraph.scss';

import PageSpinner from 'components/shared/pageSpinner/PageSpinner';

import TreeDataBodyWrapper from './treeDataBodyWrapper/treeDataBodyWrapper';

function NodesGraph(props) {
  const { treeData, loading, setTreeData, setSelectedNode } = props;

  return (
    <>
      <PageSpinner loading={loading} />

      {!loading ? (
        <div className="shared-tree-data-wrapper">
          <div className="shared-tree-data-wrapper-insidebox">
            <TreeDataBodyWrapper
              treeData={treeData}
              changeHandler={newData => setTreeData(newData)}
              searchFinish={matches => undefined}
              showMapHandler={rowInfo => {
                setSelectedNode(rowInfo?.node?.guid);
              }}
            />
          </div>
        </div>
      ) : null}
    </>
  );
}

export default NodesGraph;
